import React from 'react';
import { UI_TAG, SkeletonLoader, List } from 'oolib';
import { StyledLevelHeader } from '../styled';
import { SKELETON_HEIGHT } from '../constants';

export const TagSection = ({ 
  title, 
  options, 
  loading, 
  listProps 
}) => (
  <>
    <StyledLevelHeader>
      <UI_TAG semibold>{title}</UI_TAG>
    </StyledLevelHeader>
    {loading ? (
      <SkeletonLoader style={{ height: `${SKELETON_HEIGHT}rem` }} />
    ) : (
      <List {...listProps} style={{ padding: 0 }}/>
    )}
  </>
);
